import { IndexedRawVulns, ListRawVulnsRequest } from '../../../typings/api';
import { get, put } from '../api';

const actions = {
  fetchAll: (query: ListRawVulnsRequest) => ({
    type: 'FETCH_ALL_RAW_VULNS',
    async payload() {
      return get('/api/rawvulns', true, query);
    },
  }),
  updateRawVulns: (vulnsToUpdate: IndexedRawVulns) => ({
    type: 'UPDATE_RAW_VULNS',
    meta: {
      vulns: vulnsToUpdate,
    },
    async payload() {
      return put('/api/rawvulns', { vulns: vulnsToUpdate });
    },
  }),
};

export default actions;
